import { Button } from '@/components';
import { ResponseInfoFeoroUsuario } from '@/types/goldDate';

interface ParticipateButtonProps {
  dataInitUsuarioOro: ResponseInfoFeoroUsuario | undefined;
  onClick: () => void;
}

export const ParticipateButton = ({
  dataInitUsuarioOro,
  onClick,
}: ParticipateButtonProps) => {
  const getButtonState = () => {
    if (dataInitUsuarioOro?.participaActual) {
      return { title: 'Participando', disabled: true };
    }
    if (!dataInitUsuarioOro?.inscripcionPosible) {
      return { title: 'Ya no podés participar', disabled: true };
    }
    return { title: 'Participar', disabled: false };
  };

  const { title, disabled } = getButtonState();

  return (
    <Button
      className="md:w-[300px] h-10 p-0 px-10"
      disabled={disabled}
      type="button"
      variant="primary"
      onClick={onClick}
    >
      {title}
    </Button>
  );
};
